import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const MenuMeatballs = createSvgIcon(
  <path d="M24 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />,
  'MenuMeatballs'
);

export { MenuMeatballs };